var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHaha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.291,
    height: 36.291,
    viewBox: "0 0 36.291 36.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "haha",
    transform: "translate(-4538.439 -2167.377)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 18.145,
    cy: 18.145,
    r: 18.145,
    transform: "translate(4538.439 2167.377)",
    fill: "#f7db83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M4569.983,2185.746a13.4,13.4,0,0,1-26.8,0Z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 9.727,
    cy: 4.203,
    rx: 9.727,
    ry: 4.203,
    transform: "translate(4546.857 2190.738)",
    fill: "#e05e6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M4544.09,2181.828a.712.712,0,0,1-.145-1.41l5.475-1.14-4.15-2.33a.712.712,0,1,1,.7-1.242l5.808,3.26a.712.712,0,0,1-.2,1.318l-7.336,1.529A.726.726,0,0,1,4544.09,2181.828Z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M4569.081,2181.828a.732.732,0,0,1-.147-.015l-7.337-1.529a.712.712,0,0,1-.2-1.318l5.808-3.26a.712.712,0,0,1,.7,1.242l-4.15,2.33,5.475,1.14a.712.712,0,0,1-.144,1.41Z",
    fill: "#3c3c3b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaha);
export default __webpack_public_path__ + "static/media/haha.6b277b79c8db6d547195c1041cd22bae.svg";
export { ForwardRef as ReactComponent };